<template>
  <Row class="page3">
    <Col style="width: 34%">
      <div class="left">
        <div
          class="left1"
          style="
            height: 100%;
            padding-left: 4%;
            display: flex;
            flex-direction: column;
          "
        >
          <div class="changeItem">
            <div
              :class="currentType == 2 ? 'item active' : 'item'"
              @click="currentType = 2"
            >
              按公司
            </div>
            <div
              :class="currentType == 1 ? 'active item' : 'item'"
              @click="currentType = 1"
            >
              按板块
            </div>
          </div>
          <div style="position: relative">
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;
                padding-bottom: 20px;
              "
            >
              <div
                class="buPartWrap"
                v-for="(item, index) in currentType == 1
                  ? dataPlate
                  : dataCompany"
                :key="index"
                style="min-width: 150px"
              >
                <div
                  class="buPart"
                  @click="
                    jump(
                      '/PC/home_domesitc/' +
                        index +
                        '|' +
                        Number(item.kri) +
                        '|' +
                        Number(item.MAX_RISK_DATE_NUMBER)
                    )
                  "
                >
                  <div class="buPartTitle">
                    <span class="dot"></span>{{ index }}
                  </div>
                  <div class="line">
                    <span class="span1">KRI预警个数</span>
                    <span class="span2">{{ item.kri }}</span>
                  </div>
                  <div class="line">
                    <span class="span1">最长持续天数</span>
                    <span class="span2">{{ item.MAX_RISK_DATE_NUMBER }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="changeRateWrap overHeight"
            style="min-width: 300px; overflow-y: hodden; padding-right: 0"
          >
            <div
              class="changeRate"
              style="overflow-y: hidden; padding-right: 0"
            >
              <div class="changeRateTitle">
                <span class="dot"></span>
                <span class="word">新闻</span>
              </div>
              <el-timeline
                class="news_list overHeight"
                style="padding-right: 1vw; padding-bottom: 3vw"
              >
                <el-timeline-item
                  v-for="(item, idx) in listNews"
                  :key="idx"
                  :timestamp="item.date"
                  placement="top"
                >
                  <div>
                    <div class="news_title">
                      <el-link
                        target="_blank"
                        :href="item.url"
                        :underline="false"
                        type="warning"
                        style="color: #fff; font-size: 1vw"
                      >
                        {{ item.title }}</el-link
                      >
                    </div>
                    <div class="news_content">
                      {{ item.content }}
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>
      </div>
    </Col>
    <Col style="width: 66%; padding: 0 1%">
      <div class="center-top">
        <china-map ref="chinaMap"></china-map>
      </div>
      <div class="center-bottom">
        <div style="display: flex; align-items: center">
          <span class="dot"></span>
          <h3 class="center-bottom-title">外部市场价格指数</h3>
        </div>

        <Row class="bottom-radars" style="width: 100%">
          <div class="externalList" style="width: 100%; height: 8vw">
            <el-carousel
              height="100%"
              class="item"
              v-for="(item4, idx) in listExternal"
              :key="idx"
              direction="vertical"
              :autoplay="true"
              arrow="never"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="item in item4"
                :key="item['名称']"
                height="100%"
              >
                <div class="line1">{{ item["名称"] }}</div>
                <div
                  class="line2"
                  style="font-size: 1.1vw; display: flex; align-items: center"
                >
                  {{ item["本期"]
                  }}<span style="font-size: 0.7vw; padding-left: 0.2vw"
                    >元/kg</span
                  >
                </div>
                <div class="line3">
                  <div
                    class="left"
                    :class="Number(item['差异']) < 0 ? 'green' : 'red'"
                  >
                    {{ item["上期"] }}
                  </div>
                  <div class="right">
                    <div
                      :class="
                        Number(item['差异']) < 0 ? 'greenTrangle' : 'redTrangle'
                      "
                    ></div>
                    <div :class="Number(item['差异']) < 0 ? 'green' : 'red'">
                      {{ Number(item["差异"]).toFixed(2) }}%
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </Row>
      </div>
    </Col>
  </Row>
</template>

<script>
import { getRiskIndicators, queryExternalMarketPriceIndex } from "../api/index";
const chinaMap = () => import("./components/page4/chinaMap");
import { useDataStore } from "@/store";
import { mapActions } from "pinia";

export default {
  name: "page3",
  components: {
    chinaMap,
  },
  created() {
    this.setTitle("境内风险概览");
    this.setBackurl("/");
    this.getData();
  },
  data() {
    return {
      currentType: 2,
      dataPlate: [],
      dataCompany: [],
      listNews: [
        {
          title:
            "更大力度推进产业建设深化落实、突破提升丨光明国际总部召开2024年度务虚会",
          url: "https://mp.weixin.qq.com/s/pUa3YH6BbGLe6j0bvlYr1g ",
          content:
            "为贯彻落实习近平总书记考察上海重要讲话精神，中央经济工作会议和推进长三角一体化发展座谈会精神，落实光明食品集团工作要求，部署光明国际总部2024年各项经营发展工作。12月27日，光明国际总部召开2024年度务虚会。光明食品集团副总裁，光明国际党委书记、董事长吴通红主持会议，公司党政班子成员、董秘、总助出席会议，公司总监、各部室（中心）正副职参加会议。",
          date: "2023-12-28 18:19",
        },
        {
          title: "书记话发展｜聚焦高蛋白产业强链补链 为“实力光明”贡献梅林力量",
          url: "https://mp.weixin.qq.com/s/cqVqdxXZymJwanmJkFXbeg",
          content: `上海梅林作为光明国际高蛋白产业板块主力军，在集团肉业引擎建设进程中，如何发挥好一线作战部队作用，为光明食品集团在上海城市主副食品供应底板建设中贡献梅林力量`,
          date: "2023-12-25 16:00",
        },
        {
          title:
            "将世界美食带进千家万户，光明食品集团“THE SMART CHAIN全球食品集成分销平台”开幕",
          url: "https://baijiahao.baidu.com/s?id=1781906453769319808&wfr=spider&for=pc",
          content:
            "昨日，光明食品集团“THE SMART CHAIN全球食品集成分销平台”开幕式在第六届进博会食品及农产品展区1.1H举行。今年进博会，光明食品集团继续以“参展商、采购商、服务商”的身份深入参与其中，围绕主题“世界美食·城市厨房”，在进博会现场打造“光明城市厨房”，让参与者深度体验“吃+逛+学”的沉浸式消费，全方位展现“THE SMART CHAIN”的平台效应和全球影响力。",
          date: "2023-11-07 20:48",
        },
      ],
      listExternal: [[], [], [], [], []],
      resizeFn: null,
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setBackurl"]),
    jump(page) {
      this.$router.push(page);
    },
    async getData() {
      // 获取板块和公司
      const res = await getRiskIndicators({ type: 1 });
      if (res.code == 200) {
        this.dataPlate = res.data;
      }
      const res2 = await getRiskIndicators({ type: 2 });
      if (res2.code == 200) {
        this.dataCompany = res2.data;
      }
      const res3 = await queryExternalMarketPriceIndex();
      let data = res3.data["外部市场价格指数明细"][0];
      let externalIndex = 0;
      for (let i in data) {
        console.log(Number(data[i]["差异"]), Number(data[i]["本期"][i]));
        data[i]["name4"] = (
          Number(data[i]["差异"]) / Number(data[i]["本期"])
        ).toFixed(2);
        this.listExternal[externalIndex].push(data[i]);
        externalIndex++;
        if (externalIndex == 5) {
          externalIndex = 0;
        }
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/index.less";
.externalList {
  background: rgba(87, 87, 87, 0.3);
  padding: 1vw;
  height: auto;
  margin-top: 0.5vw;
  .item {
    height: 100%;
    position: relative;
    width: 20%;
    display: inline-block;
    padding-right: 1.5vw;
    padding-left: 1vw;

    &::after {
      display: block;
      content: "";
      position: absolute;
      width: 1px;
      height: 2vw;
      background: #fff;
      opacity: 0.2;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    &:last-child::after {
      width: 0;
    }

    .line1 {
      color: #bf9d63;
      font-size: 0.9vw;
    }
    .line2 {
      font-weight: 600;
      color: #fff;
      font-size: 1.8vw;
    }
    .line3 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.8vw;
      .right {
        display: flex;
        align-items: center;
      }
      .green {
        color: #6bbb57;
      }
      .red {
        color: #f06161;
      }
      .redTrangle {
        /* 1.首先设置盒子宽高都为0 */
        width: 0;
        height: 0;
        /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
        border: 4px solid transparent;
        /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
        border-top: none;
        /*4.最后设置边框颜色，显示出三角形*/
        border-bottom-color: #f06161;
        margin-right: 3px;
      }
      .greenTrangle {
        width: 0px;
        height: 0px;
        border: 4px solid transparent;
        border-top-color: #6bbb57;
        margin-right: 3px;
      }
    }
  }
}
.news_list {
  .news_title {
    color: #fff;
    font-size: 0.8vw;
    font-weight: 600;
  }
  .news_content {
    margin-top: 0.5vw;
    color: #fff;
    font-size: 0.8vw;
    opacity: 0.6;
  }
}
.center-bottom {
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  .background-4-img;
  padding: 20px;
  .center-bottom-title {
    font-size: 16px;
    line-height: 24px;
    color: rgba(191, 157, 99, 1);
    font-weight: 300;
  }
}
.dot {
  margin-right: 10px;
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background: linear-gradient(180deg, #bf9d63 0%, rgba(217, 217, 217, 0) 100%);
}
.tableList {
  .item {
    display: flex;
    align-items: center;
    &:nth-child(odd) {
      background: rgba(87, 87, 87, 0.5);
    }
    height: 38px;
    line-height: 38px;
    justify-content: space-between;
    .left {
      font-size: 1vw;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 10px;
    }
    .center {
      font-weight: 400;
      font-size: 1vw;
      color: #ffffff;
      text-align: center;
    }
    .right {
      text-align: right;
      padding-right: 10px;
      font-weight: 400;
      font-size: 1vw;
      color: #f06161;
      .dotRed {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #f06161;
      }
      .dotGreen {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #6bbb57;
      }
    }
    > div {
      width: 33%;
    }
  }
}
.changeRateWrap {
  flex: 1;
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  //   height: calc(100% - 32px - 40%);
  position: relative;
  //   top: -20px;

  .changeRateTitle {
    display: flex;
    align-items: center;

    .word {
      font-size: 16px;
      color: #bf9d63;
    }
  }
}
.page3 {
  .left1 {
    .changeRate {
      padding-left: 3%;
      padding-right: 4%;
      width: 100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
        linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
        linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
        linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
        linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
      background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
      padding: 10px 20px;
      .changeRateTitle {
        color: #bf9d63;
        margin-bottom: 10px;
      }
    }
    .buPartWrap {
      cursor: pointer;
      display: inline-block;
      width: 45%;
      height: 8.5vw;
      // height: 180px;
      //   background: rgba(87, 87, 87, 0.3);
      //   border: 1px solid #4d4a48;
      &:nth-child(n + 3) {
        margin-top: 20px;
      }
      .buPart {
        width: 100%;
        height: 100%;
        background: linear-gradient(to left, #bf9d63, #bf9d63) left top
            no-repeat,
          linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
          linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
          linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
          linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
        background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
        padding-left: 1vw;
        padding-right: 1vw;
        padding-top: 0.5vw;
        padding-bottom: 0.5vw;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        // padding: 1.5vw 20px 0;
        .buPartTitle {
          color: #bf9d63;
          // font-weight: 600;
          // margin-bottom: 28px;
          //   font-size: 20px;
          font-size: 1.2vw;
          line-height: 27px;
        }
        .line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          //   line-height: 34px;
          font-weight: 400;
          .span1 {
            color: #ffffff;
            opacity: 0.6;
            font-size: 1vw;
            // font-size: 1vw;
          }
          .span2 {
            font-size: 1.2vw;
            color: #ffffff;
            opacity: 0.8;
            // font-size: 1.5vw;
          }
        }
      }
      background: rgba(87, 87, 87, 0.3);
      border: 1px solid #4d4a48;
      box-sizing: border-box;
    }
    .changeItem {
      font-size: 0.9vw;
      margin-bottom: 20px;
      position: relative;
      //   top: -60px;

      .item {
        cursor: pointer;
        text-align: center;
        display: inline-block;
        // margin-right: 40px;
        min-width: 105px;
        height: 40px;
        line-height: 40px;
        color: #bf9d63;
        // padding: 8px 14px;
        color: #fff;
        &.active {
          background: #4a3e29;
          border-radius: 60px;
          color: #bf9d63;
        }
      }
    }
  }
  height: 100%;
  width: 100%;
  padding: 14px 20px 20px;
  //   background: #03044a;
  // overflow: hidden;

  .ivu-col {
    height: 100%;
    float: left;
  }

  .left,
  .right1-1,
  .center-bottom {
    // background: rgba(87, 87, 87, 0.3);
    // border: 1px solid #4d4a48;
    height: 100%;
    // border: 1px solid #0d2451;
    position: relative;
    // background: #151456;

    #left_5 {
      height: 100%;
      width: 45%;
      float: left;
    }

    #left_6 {
      height: 100%;
      width: 55%;
      float: left;
    }

    .circular {
      height: 100%;

      .canvas {
        height: 100%;
        width: 30%;
        float: left;

        .subtitle {
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          height: 25px;
          padding: 10px 0;
          text-align: center;
        }

        .canvasList {
          height: calc(~"100% - 25px");
          text-align: center;
        }
      }
    }

    .left1 {
      //   border-bottom: 1px solid #0d2451;
      //   background: #151456;
    }

    .title {
      position: absolute;
      display: inline-block;
      color: #6eddf1;
      border: 2px solid #6eddf1;
      height: 18px;
      padding: 0 2px;
      left: 50%;
      transform: translate(-50%, -50%);

      .title-text {
        position: relative;
        font-size: 16px;
        background: #09102e;
        display: inline-block;
        padding: 0 4px;
        transform: translateY(-5px);
      }
    }
  }

  .center-top {
    height: 70%;
  }

  .center-bottom {
    height: 30%;

    .bottom-radars {
      height: 100%;
    }

    .bottom-bars {
      height: 45%;
    }
  }

  .right-1 {
    height: 30%;

    .right1-1 {
      height: 92%;
    }
  }

  .right-2 {
    height: 40%;
  }
}
</style>
